module.exports = __webpack_public_path__ + "fonts/Kite Script.f314c9ea.ttf";